import { render } from "./LinkNotificationWithEntity.vue?vue&type=template&id=0284166d&scoped=true&ts=true"
import script from "./LinkNotificationWithEntity.vue?vue&type=script&lang=ts"
export * from "./LinkNotificationWithEntity.vue?vue&type=script&lang=ts"

import "./LinkNotificationWithEntity.vue?vue&type=style&index=0&id=0284166d&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0284166d"]])

export default __exports__